import { getHermesQueryParam } from '@rsos/utils/metaTags';
import HermesClientBase from './HermesClientBase';

/**
 * Hermes real-time data messaging service client for the `/hermes/connect`
 * endpoint. The connection and reconnection lifecycle lives in
 * HermesClientBase, shared with the `/v1/stream` client.
 */
class Hermes extends HermesClientBase {
  constructor(...args) {
    super(...args);
    this._client = 'hermesConnect';
  }

  /**
   * Read per connection rather than fixed at construction, because the
   * capability can arrive after the client is built.
   * @private
   */
  get _connectPath() {
    return `/${this.hasHermesV2Access ? 'v2' : 'v1'}/hermes/connect`;
  }

  /** @private */
  get _extraQueryParams() {
    return getHermesQueryParam();
  }
}

export default Hermes;
